import Cookies from 'js-cookie'
import store from '@/store'
import axios from 'axios'
import { getAccessToken } from '@/utils/userInfo'
import Vue from 'vue'

/**
 * 权限
 * @param {*} key
 */
export function hasPermission (key) {
  return window.SITE_CONFIG['permissions'].findIndex(item => {
    return key === item.perms
  }) !== -1
}

/**
 * 获取字典数据列表
 * @param dictType  字典类型
 */
export function isWeiXin () {
  // 获取访问终端的版本信息,如果终端信息中存在微信标识' micromessenger ',则是微信
  var ua = window.navigator.userAgent.toLowerCase()
  // eslint-disable-next-line eqeqeq
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}

/**
 * 获取字典数据列表
 * @param dictType  字典类型
 */
export function getDictDataList (dictType) {
  if (!dictType) {
    return []
  }
  if (!window.SITE_CONFIG['dictList']) {
    return false
  }
  const type = window.SITE_CONFIG['dictList'][dictType]
  // .find((element) => (element.dictType === dictType))
  if (type) {
    return type.dataList
  } else {
    return []
  }
}

/**
 * 获取字典名称
 * @param dictType  字典类型
 * @param dictValue  字典值
 */
export function getDictLabel (dictType, dictValue) {
  if (!window.SITE_CONFIG['dictList']) {
    return dictValue
  }
  const type = window.SITE_CONFIG['dictList'][dictType]
  // .find((element) => (element.dictType === dictType))
  if (type && type.length) {
    const val = type.find((element) => {
      return element.code === dictValue
    })
    if (val) {
      return val.value
    } else {
      return dictValue
    }
  } else {
    return dictValue
  }
}

/**
 * 清除登录信息
 */
export function clearLoginInfo () {
  localStorage.clear()
  sessionStorage.removeItem('plcTip')
  store.commit('resetStore')
  Cookies.remove('access_token_shop')
  Cookies.remove('access_token_shop', {
    domain: location.origin.includes('plantmate.supcon.com') ? '.supcon.com' : '.plantmate.com'
  })
  store.commit('defaultCompanyId', '')
  localStorage.setItem('defaultCompanyId', '')
  window.SITE_CONFIG['dynamicMenuRoutesHasAdded'] = false
  Cookies.remove('userInfo')
}

/**
 * 获取uuid
 */
export function getUUID () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
  })
}

/**
 * 获取svg图标(id)列表
 */
export function getIconList () {
  var res = []
  document.querySelectorAll('svg symbol').forEach(item => {
    res.push(item.id)
  })
  return res
}

/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate (data, id = 'id', pid = 'pid') {
  var res = []
  var temp = {}
  for (var i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i]
  }
  for (var k = 0; k < data.length; k++) {
    if (!temp[data[k][pid]] || data[k][id] === data[k][pid]) {
      res.push(data[k])
      continue
    }
    if (!temp[data[k][pid]]['children']) {
      temp[data[k][pid]]['children'] = []
    }
    temp[data[k][pid]]['children'].push(data[k])
    data[k]['_level'] = (temp[data[k][pid]]._level || 0) + 1
  }
  return res
}

// 移除链接上空的参数
function removeEmptyParams (url) {
  // 分解URL结构
  var match = url.match(/^([^?#]*)(\?[^#]*)?(#.*)?$/)
  if (!match) return url

  var base = match[1] // 基础部分（协议+路径）
  var query = match[2] || '' // 查询参数
  var hash = match[3] || '' // 哈希部分

  // 处理查询参数
  var params = []
  var pairs = query.substr(1).split('&') // 去掉开头的?

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i]
    if (pair === '') continue // 跳过空参数

    var eqPos = pair.indexOf('=')
    var key = eqPos === -1 ? pair : pair.substr(0, eqPos)
    var value = eqPos === -1 ? '' : pair.substr(eqPos + 1)

    // 保留非空参数（兼容0/false等有效值）
    if (value !== '') {
      params.push(
        encodeURIComponent(key) +
          (value !== '' ? '=' + encodeURIComponent(value) : '')
      )
    }
  }

  // 重建URL
  var newQuery = params.length > 0 ? '?' + params.join('&') : ''
  return base + newQuery + hash
}
// 新启页面打开
export function openOther (url = '', other = false) {
  let configUrl = window.location
  if (url) {
    const isWeixin = isWeiXin()
    let newUrl = ''
    try {
      newUrl = removeEmptyParams(url)
    } catch (error) {
      newUrl = url
    }
    let openUrl = other ? url : configUrl.origin + '/' + newUrl
    window.open(openUrl, isWeixin ? '_self' : '_blank')
  }
}
export function spliceString (str = '', length = 0) {
  if (typeof str !== 'string') { return str }
  if (IEVersion() < 0) { return str }
  if (Number(length) >= 0 && length > 0) {
    if (str.length >= length) {
      return str.substr(0, length) + '...'
    } else {
      return str
    }
  } else {
    return str
  }
}
function IEVersion () {
  var userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
  var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 // 判断是否IE<11浏览器
  var isEdge = userAgent.indexOf('Edge') > -1 && !isIE // 判断是否IE的Edge浏览器
  var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
  if (isIE) {
    var reIE = new RegExp('MSIE (\\d+\\.\\d+)')
    reIE.test(userAgent)
    var fIEVersion = parseFloat(RegExp['$1'])
    if (fIEVersion === 7) {
      return 7
    } else if (fIEVersion === 8) {
      return 8
    } else if (fIEVersion === 9) {
      return 9
    } else if (fIEVersion === 10) {
      return 10
    } else {
      return 6 // IE版本<=7
    }
  } else if (isEdge) {
    return 'edge' // edge
  } else if (isIE11) {
    return 11 // IE11
  } else {
    return -1 // 不是ie浏览器
  }
}

/**
 * 格式化时间
 * @param {*} str
 * @param {*} isFullDate 是否带时分秒
 */
export function fomatDateTime (str, isFullDate = false) {
  let result = ''
  if (str) {
    let date = new Date(str)
    let mon = date.getMonth() + 1
    let day = date.getDate()
    result = date.getFullYear() + '-' + (mon > 10 ? mon : '0' + mon) + '-' + (day > 10 ? day : '0' + day)
    if (isFullDate) {
      let hour = date.getHours()
      let min = date.getMinutes()
      let sec = date.getSeconds()
      result += ' ' + (hour > 10 ? hour : '0' + hour) + ':' + (min > 10 ? min : '0' + min) + ':' + (sec > 10 ? sec : '0' + sec)
    }
    return result
  } else {
    return result
  }
}

export function fomatDate (data, fmt) {
  var o = {
    'M+': data.getMonth() + 1,
    'd+': data.getDate(),
    'h+': data.getHours(),
    'm+': data.getMinutes(),
    's+': data.getSeconds(),
    'q+': Math.floor((data.getMonth() + 3) / 3),
    'S': data.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (data.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

window._axiosPromiseArr = []
const CancelToken = axios.CancelToken

// 文件下载使用
export async function downFile (url, fileName, fileType, item) {
  await axios({
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + getAccessToken()
    },
    responseType: 'blob', // 一定要写
    url: url,
    data: {
    },
    cancelToken: new CancelToken(function executor (c) {
      // executor 函数接收一个 cancel 函数作为参数
      window._axiosPromiseArr.push(c)
    }),
    onDownloadProgress: function ({ total, loaded }) {
      const percentage = (loaded / total) * 100
      if (!item) return
      item.percentage = Number(percentage.toFixed(2))
    }
  })
    .then((res) => {
      if (res.data.size > 0) {
        const reader = new FileReader()
        reader.onload = (e) => {
          const blob = new Blob([res.data], {
            type: res.data.type
          })
          if ('msSaveOrOpenBlob' in navigator) {
            // 'IE'
            window.navigator.msSaveOrOpenBlob(blob, fileName + '.xls')
          } else {
            const link = document.createElement('a')
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            // link.download = res.headers['content-disposition'] // 下载后文件名
            link.download = doSuffix(fileName, fileType)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
          Vue.prototype.$message.success(`文件${fileName}下载完成` || '下载成功')
        }
        reader.readAsText(res.data)
      }
    })
    .catch(e => {
      // downLoad(url, doSuffix(fileName, fileType))
    })
}

export function downLoad (href, fileName) {
  const elink = document.createElement('a')
  elink.style.display = 'none'
  elink.setAttribute('href', href)
  // elink.setAttribute('target', '_blank')
  elink.download = fileName
  document.body.appendChild(elink)
  elink.click()
  document.body.removeChild(elink)
}

// 处理oss文件路径没有后缀名的情况处理出一个文件名称
export function doSuffix (fileName, fileType) {
  const suffixArr = fileName.split('.')
  if (suffixArr.length) {
    const suffix = suffixArr[suffixArr.length - 1]
    if (suffix.length < 6) {
      return fileName
    } else {
      return `${fileName}.${fileType}`
    }
  } else {
    return `${fileName}.${fileType}`
  }
}

/**
 * 判断元素是否出现在可视区内
 *
 * @param {element} el
 * @param {boolean} partiallyVisible
 */
export const elementIsVisibleInViewport = (el, partiallyVisible = false, offsetTop = 0, offsetBottom = 0) => {
  const {
    top,
    left,
    bottom,
    right
  } = el.getBoundingClientRect()
  const {
    innerHeight,
    innerWidth
  } = window
  return partiallyVisible
    ? ((top > offsetTop && top < innerHeight) || (bottom > offsetBottom && bottom < innerHeight)) &&
    ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
    : top >= offsetTop && left >= 0 && bottom <= innerHeight && right <= innerWidth
}

/**
 * 判断元素是否出现在可视区内
 *
 * @param {element} el
 * @param {offset} 偏移距离
 */
export const isElementInViewport = (el, offsetBottom = 0, offsetTop = 0) => {
  let box = el.getBoundingClientRect()
  let top = (box.top >= offsetTop)
  let left = (box.left >= 0)
  let bottom = (box.bottom <= (window.innerHeight || document.documentElement.clientHeight) + offsetBottom)
  let right = (box.right <= (window.innerWidth || document.documentElement.clientWidth))
  return (top && left && bottom && right)
}

/**
 * 平滑滚动到指定位置
 *
 * @param {element} el
 * @param {offset} 偏移距离
 * @param {compatible} 是否使用兼容属性scrollIntoView
 */
let timer = null
export const scrollIntoView = (traget, offset = 0, compatible = false) => {
  const tragetElem = traget
  if (!tragetElem) return
  const tragetElemPostition = tragetElem.offsetTop - offset
  if (timer) {
    clearInterval(timer)
  }
  // 判断是否支持新特性
  if (
    typeof window.getComputedStyle(document.body).scrollBehavior !==
    'undefined' &&
    compatible
  ) {
    tragetElem.scrollIntoView({
      behavior: 'smooth'
      // inline: 'nearest'
    })
  } else {
    // 当前滚动高度
    let scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop
    // 滚动step方法
    timer = setInterval(() => {
      // 距离目标滚动距离
      let distance = tragetElemPostition - scrollTop

      // 目标需要滚动的距离，也就是只走全部距离的五分之一
      scrollTop = scrollTop + distance / 5
      if (Math.abs(distance) < 1) {
        window.scrollTo(0, Math.round(tragetElemPostition))
        clearInterval(timer)
      } else {
        window.scrollTo(0, Math.round(scrollTop))
      }
    }, 20)
  }
}

// 转换文件大小
export const formatFileSize = (bytes) => {
  if (bytes < 1024) {
    return `${bytes} B` // 小于1KB，直接显示字节
  } else if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(2)} KB` // 转换为KB
  } else if (bytes < 1024 * 1024 * 1024) {
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB` // 转换为MB
  } else {
    return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB` // 转换为GB
  }
}
